<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/myAccountList/">My Accounts</a></li>
      <li class="breadcrumb-item active" aria-current="page">Warehouse Details</li>
    </ol>
  </nav>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black ">Summary</h2>
          <div class="row mt-3">
            <div class="col-3">
              <label class="text-black mb-3"><b>Warehouse Name :</b><span class="ml-1">{{warehouseDetails?.warehouseName}}</span></label>
            </div>
            <div class="col-3">
              <label class="text-black mb-3"><b>Start Date :</b><span class="ml-1">{{warehouseDetails?.startDate}}</span></label>
            </div>
            <div class="col-3">
              <label class="text-black mb-3"><b>End Date :</b><span class="ml-1">{{warehouseDetails?.endDate}}</span></label>
            </div>
            <div class="col-3">
              <label class="text-black mb-3"><b>Unit Cost :</b><span class="ml-1">{{warehouseDetails?.cost}}</span></label>
            </div>
            <div class="col-3">
              <label class="text-black mb-3"><b>Units Assigned :</b><span class="ml-1">{{warehouseDetails?.unitsAssigned}}</span></label>
            </div>
            <div class="col-3">
              <label class="text-black mb-3"><b>Duration :</b><span class="ml-1">{{warehouseDetails?.duration}}</span></label>
            </div><div class="col-3">
            <label class="text-black mb-3"><b>Auto Renew :</b><span class="ml-1">{{warehouseDetails?.autoRenewFlag?'Yes' : 'No'}}</span></label>
          </div>
            <div class="col-3">
              <label class="text-black mb-3"><b>Billing Type :</b><span class="ml-1">{{warehouseDetails?.billingType| titlecase}}</span></label>
            </div>

          </div>
        </div>
      </div>
    </div>
  <div class="row">
    <div class="col">
      <ul class="list-inline tab-list">
          <li  class="list-inline-item">
            <a (click)="populateTabData('stock_levels');" [ngClass]="{'active': tabClicked === 'stock_levels'}">Stock Levels</a></li>
        <li  class="list-inline-item">
          <a (click)="populateTabData('orders');" [ngClass]="{'active': tabClicked === 'orders'}">Orders</a></li>
        <li  class="list-inline-item">
          <a (click)="populateTabData('additional_details');" [ngClass]="{'active': tabClicked === 'additional_details'}">Additional Details</a></li>
      </ul>
    </div>
    </div>
  <div class="row" *ngIf="tabClicked === 'stock_levels'">
    <div class="col">
      <div class="inner-box">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>SKU</th>
              <th>Product Name</th>
              <th>Product Type</th>
              <th>Store SKU</th>
              <th>Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let product of warehouseDetails?.productsList">
              <td>{{product.sku|uppercase}}</td>
              <td>{{product.productName|titlecase}}</td>
              <td>{{product.productType}}</td>
              <td>{{product?.storeSku|uppercase}}</td>
              <td>{{product.minQuantity}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="tabClicked === 'orders'">

    <div class="col">
      <div class="inner-box">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Order Number</th>
              <th>Order Type</th>
              <th>Order Date</th>
              <th>Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let pro of orderDetails">
              <td>{{pro.activityOrderNumber}}</td>
              <td>{{(pro.activityType == 'WORK_ORDER' ? 'Work Order' :
                (pro.activityType == 'STOCK' ? 'Inbound Orders' :
                (pro.activityType == 'ORDER' ? 'Order' : "Orders")))}}</td>
              <td>{{pro.activityOrderedDate}}</td>
              <td>{{pro.quantity}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="tabClicked === 'additional_details'">
    <div class="col">
      <div class="inner-box">
        <h2 class="text-black ">Additional Details ......</h2>
      </div>
    </div>
  </div>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/myAccountList" class="btn btn-cancel" >Close</button>
    </div>
  </div>
</div>
